import { getStorage, setStorage } from './storage';
import _ from 'lodash';

export let getToken = () => {
  let token = getStorage('token');

  if (!_.isString(token) || _.isEmpty(token)) {
    token = '';
  }

  return token;
};

export let setToken = token => {
  setStorage('token', token);
};

export let getRememberedAccount = () => {
  let account = getStorage('remembered_account');

  if (!_.isString(account) || _.isEmpty(account)) {
    account = '';
  }

  return account;
};

export let setRememberedAccount = account => {
  setStorage('remembered_account', account);
};
